/**
 * In jsdom 21.0.0+, window.location became non-configurable and mostly read-only,
 * making it impossible to mock window.location.href directly in tests using
 * Object.defineProperty. Additionally, window.location.href cannot be spied on
 * using jest.spyOn because the property is non-configurable.
 *
 * This helper function can be mocked in test environments, allowing tests
 * to verify href assignments without directly mocking window.location.href.
 * Reference: https://github.com/jsdom/jsdom/issues/3492
 */
export const setWindowHref = (url: string) => {
  window.location.href = url;
};
